<template>
  <div>
    <div class="rm4-card rm4-card--auto-height rm4-card--p1-2">
      <InputOverview :picker="true"></InputOverview>
    </div>

    <div class="rm4-card rm4-card--p2-1">
      <div class="rm4-time-grid">
        <div class="rm4-time-grid__container" v-for="time in times" :key="time">
          <div
            class="rm4-time-grid__time-slot"
            :class="[
              {
                'rm4-time-grid__time-slot--selected':
                  time[0].timetxt === $store.time
              },
              getStatusClass(time[0].status)
            ]"
            @click="process(time[0])"
          >
            <div class="rm4-time-grid__time-slot__time">
              <div
                class="rm4-multi-icon"
                :class="[{ 'multi-icon--compact': time[0].endtime }]"
                v-if="
                  time[0].status.includes(status.OUTSIDE) &&
                    time[0].status.includes(status.DRINKS)
                "
              >
                <span class="material-symbols-outlined">deck</span>
                <i class="rm4-fal rm4-fa-martini-glass"></i>
              </div>
              <span
                v-if="
                  time[0].status.includes(status.OUTSIDE) &&
                    !time[0].status.includes(status.DRINKS)
                "
                class="material-symbols-outlined"
                >deck</span
              >
              <i
                v-else-if="
                  !time[0].status.includes(status.OUTSIDE) &&
                    time[0].status.includes(status.DRINKS)
                "
                class="rm4-fal rm4-fa-martini-glass"
              >
              </i>
              <span>{{ time[0].timetxt }}</span>
            </div>
            <div
              v-if="
                time[0].endtime && !hasStatus(time[0].status, status.BLOCKED)
              "
              class="rm4-time-grid__time-slot__endtime"
            >
              till {{ time[0].endtime }}
            </div>
          </div>
        </div>
      </div>
      <div v-show="$store.loading" class="rm4-loader"></div>
    </div>

    <div class="rm4-actions">
      <div class="rm4-button" @click="goBack"><i class="fal fa-chevron-left"></i> Back</div>
    </div>

    <modal
      name="rm4-blocked-modal"
      :height="'auto'"
      :adaptive="true"
      :classes="'rm4-modal-content'"
    >
      <div class="rm4-modal-container">
        <div class="rm4-modal-close" @click="$modal.hide('rm4-blocked-modal')">
          <span class="rm4-modal-close-icon">&#10005;</span>
        </div>
        <div v-html="blockedText"></div>
      </div>
    </modal>

    <modal
      name="rm4-terras-modal"
      :height="'auto'"
      :adaptive="true"
      :classes="'rm4-modal-content'"
    >
      <div class="rm4-modal-container rm4-modal-container--terras">
        <div class="rm4-modal-close" @click="$modal.hide('rm4-terras-modal')">
          <span class="rm4-modal-close-icon">&#10005;</span>
        </div>
        <div
          v-if="!hasStatus(terrasTimeStatus, status.DRINKS)"
          class="rm4-modal-container--terras__bold-text"
        >
          This reservation is for <strong>OUTSIDE</strong>, on our lovely
          terrace.
        </div>
        <div
          v-if="hasStatus(terrasTimeStatus, status.DRINKS)"
          class="rm4-modal-container--terras__bold-text"
        >
          This reservation is for <strong>DRINKS ONLY OUTSIDE</strong>, on our
          lovely terrace.
        </div>
        <p class="rm4-modal-container--terras__small-text"></p>
        <p v-if="endTimeValue">{{ endtimeText }}</p>
        <div
          v-if="!hasStatus(terrasTimeStatus, status.DRINKS)"
          class="rm4-modal-container--terras__large-text"
        >
          Do you want a table outside?
        </div>
        <div
          v-if="hasStatus(terrasTimeStatus, status.DRINKS)"
          class="rm4-modal-container--terras__large-text"
        >
          Do you want a table for drinks only outside?
        </div>

        <div class="rm4-actions rm4-actions--modal">
          <div class="rm4-button rm4-button--primary" @click="setTerrasTime">
            Yes
          </div>
          <div class="rm4-button" @click="$modal.hide('rm4-terras-modal')">
            Back
          </div>
        </div>
      </div>
    </modal>

    <modal
      name="rm4-endtime-modal"
      :height="'auto'"
      :adaptive="true"
      :classes="'rm4-modal-content'"
    >
      <div class="rm4-modal-container">
        <div class="rm4-modal-close" @click="$modal.hide('rm4-endtime-modal')">
          <span class="rm4-modal-close-icon">&#10005;</span>
        </div>
        <div>
          {{
            hasStatus(endTimeStatus, status.DRINKS)
              ? endtimeDrinkText
              : endtimeText
          }}
          Are you sure you want to continue?
        </div>
        <div class="rm4-actions rm4-actions--modal">
          <div
            class="rm4-button rm4-button--tertiary"
            @click="process(endTimeValue, true)"
          >
            Ok
          </div>
          <div class="rm4-button" @click="$modal.hide('rm4-endtime-modal')">
            Cancel
          </div>
        </div>
      </div>
    </modal>

    <modal
      name="rm4-drinks-modal"
      :height="'auto'"
      :adaptive="true"
      :classes="'rm4-modal-content'"
    >
      <div class="rm4-modal-container">
        <div class="rm4-modal-close" @click="$modal.hide('rm4-drinks-modal')">
          <span class="rm4-modal-close-icon">&#10005;</span>
        </div>
        <div>Je hebt een borrel tijdvak gekozen.</div>
        <div class="rm4-actions rm4-actions--modal">
          <div
            class="rm4-button rm4-button--tertiary"
            @click="process(drinksValue, true)"
          >
            Ok
          </div>
          <div class="rm4-button" @click="$modal.hide('rm4-drinks-modal')">
            Cancel
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import InputOverview from "./InputOverview";

const dateToday = moment().format("YYYY-MM-DD");
const STATUS = {
  OPEN: "open",
  VIP: "vip",
  OUTSIDE: "terras",
  DRINKS: "drinks",
  BLOCKED: "blocked"
};

export default {
  name: "TimeSelect",
  components: { InputOverview },
  data: function() {
    return {
      times: [],
      selectedEndtime: null,
      drinksValue: null,
      endTimeValue: null,
      terrasTime: null,
      status: STATUS
    };
  },
  created() {
    this.processTimes();
  },
  methods: {
    processTimes() {
      const filtered = _.filter(this.$store.timeSlots, time =>
        moment(`${dateToday} ${_.get(time, "0.timetxt")}`).isBetween(
          moment(`${dateToday} ${this.$store.frame.time_from}`),
          moment(`${dateToday} ${this.$store.frame.time_to}`),
          undefined,
          "[]"
        )
      );

      if (!_.size(filtered)) {
        this.$store.currentStep = this.$step.SECOND;
      }

      this.times = _.map(filtered, time => {
        _.set(time, "0.status", this.timeClass(time));
        return time;
      });

      const currentTime = _.find(this.times, time => {
        return time[0].timetxt === this.$store.time;
      });

      if (currentTime && currentTime[0].status.includes(STATUS.BLOCKED)) {
        this.$store.time = null;
      }
    },
    timeClass(time) {
      const classes = [];

      if (
        Number(_.get(time, "0.maxpax")) < 1 &&
        _.get(time, "0.specialmaxpax") &&
        Number(_.get(time, "0.specialmaxpax")) > 0 &&
        Number(_.get(time, "0.specialmaxpax")) >= this.peopleCount
      ) {
        return [STATUS.VIP];
      }

      if (
        Number(_.get(time, "0.maxpax")) < 1 ||
        this.peopleCount > _.get(time, "0.maxpax")
      ) {
        if (_.get(time, "0.maxpaxoutside") >= this.peopleCount) {
          classes.push(STATUS.OUTSIDE);
        } else {
          return [STATUS.BLOCKED];
        }
      }

      if (
        Number(_.get(time, "0.maxpax")) > 0 &&
        _.lowerCase(_.get(time, "0.reservationtype")) === STATUS.DRINKS
      ) {
        if (!classes.length) {
          classes.push(STATUS.OPEN);
        }

        classes.push(STATUS.DRINKS);
      }

      return classes.length ? classes : [STATUS.OPEN];
    },
    async process(time, skipModal = false) {
      this.selectedEndtime = _.get(time, "endtime");

      if (this.selectedEndtime) {
        if (!skipModal && !this.hasStatus(time.status, STATUS.BLOCKED)) {
          this.endTimeValue = time;

          if (!time.status.includes(STATUS.OUTSIDE)) {
            this.$modal.show("rm4-endtime-modal");

            return;
          }
        }
      } else {
        this.endTimeValue = null;
      }

      if (
        !skipModal &&
        !this.selectedEndtime &&
        !time.status.includes(STATUS.OUTSIDE) &&
        time.status.includes(STATUS.DRINKS)
      ) {
        this.drinksValue = time;
        this.$modal.show("rm4-drinks-modal");

        return;
      }

      if (time.status.includes(STATUS.OPEN)) {
        this.$store.isOutside = false;
        this.$store.isVip = false;
        this.$store.isDrinkOnly = time.status.includes(STATUS.DRINKS);
        this.$store.time = _.get(time, "timetxt");
        this.$store.endTime = _.get(time, "endtime");
        this.$store.isPreferredTimeslot = _.get(time, "pf", 0);
        this.$store.currentStep = this.$step.FOURTH;

        await this.saveDataLog({
          step: 2,
          firstname: this.$store.firstName,
          lastname: this.$store.lastName,
          email: this.$store.email,
          phone: this.$store.phone,
          bookdate: moment(this.$store.date).format("YYYY-MM-DD"),
          adult: this.$store.adults,
          children: this.$store.kids,
          booktime: this.$store.time
        });

        return;
      }

      if (time.status.includes(STATUS.BLOCKED)) {
        this.$modal.show("rm4-blocked-modal");

        return;
      }

      if (time.status.includes(STATUS.VIP)) {
        this.$store.isOutside = false;
        this.$store.time = _.get(time, "timetxt");
        this.$store.endTime = _.get(time, "endtime");
        this.$store.currentStep = this.$step.VIP;
        this.$store.isPreferredTimeslot = _.get(time, "pf", 0);

        await this.saveDataLog({
          step: 2,
          firstname: this.$store.firstName,
          lastname: this.$store.lastName,
          email: this.$store.email,
          phone: this.$store.phone,
          bookdate: moment(this.$store.date).format("YYYY-MM-DD"),
          adults: this.$store.adults,
          children: this.$store.kids,
          booktime: this.$store.time
        });

        return;
      }

      if (time.status.includes(STATUS.OUTSIDE)) {
        this.terrasTime = time;
        this.$modal.show("rm4-terras-modal");

        return;
      }
    },
    setTerrasTime() {
      this.$store.isOutside = true;
      this.$store.isVip = false;
      this.$store.isDrinkOnly = this.terrasTime.status.includes(STATUS.DRINKS);
      this.$store.time = _.get(this.terrasTime, "timetxt");
      this.$store.endTime = _.get(this.terrasTime, "endtime");
      this.$store.isPreferredTimeslot = _.get(this.terrasTime, "pf", 0);
      this.$store.currentStep = this.$step.FOURTH;
    },
    goBack() {
      this.$store.autoProceed = false;
      this.$store.currentStep = this.$step.SECOND;
    }
  },
  computed: {
    peopleCount() {
      return this.$store.adults + this.$store.kids;
    },
    blockedText() {
      return (
        _.get(this.$store, "groups.msg") ||
        _.get(this.$store, "info.text_full") ||
        `Max. reservations reached for this timeframe.
        NO PROBLEM, Please drop by without reservation.
        Maybe you have to wait a few minutes for a free
        table, but you can have a drink in our lounge.
        (we always keep enough tables free for walk-in)`
      );
    },
    endtimeText() {
      return `You have selected a table time with an end time of ${this.selectedEndtime}.`;
    },
    endtimeDrinkText() {
      return `You have selected a drinks only table time with an end time of ${this.selectedEndtime}`;
    },
    endTimeStatus() {
      return _.get(this.endTimeValue, "status", []);
    },
    terrasTimeStatus() {
      return _.get(this.terrasTime, "status", []);
    },
    hasStatus() {
      return (haystack, needle) =>
        (_.isArray(haystack) ? haystack : []).includes(needle);
    },
    getStatusClass() {
      return status =>
        (_.isArray(status) ? status : [])
          .map(stat => `rm4-time-grid__time-slot--${stat}`)
          .join(" ");
    }
  },
  watch: {
    "$store.timeSlots": {
      handler: function() {
        this.processTimes();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.rm4-card--auto-height {
  z-index: 1;
}

.rm4-time-grid {
  display: flex;
  flex-wrap: wrap;

  .rm4-time-grid__container {
    width: 25%;

    .rm4-time-grid__time-slot {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      height: 39px;
      font-size: 15px;
      text-align: center;
      padding: 0 8px;
      margin: 8px;
      border-radius: 11px;

      .rm4-time-grid__time-slot__time {
        display: flex;
        justify-content: center;
        align-items: center;

        .rm4-multi-icon {
          display: flex;
          flex-direction: column;
          align-items: center;
          line-height: 12px;
          max-width: 21px;

          .rm4-fal {
            height: 16px;
          }

          &.multi-icon--compact {
            flex-direction: row;

            .material-symbols-outlined {
              font-size: 10px;
              margin: 0;
            }

            .rm4-fal {
              font-size: 8px;
              height: auto;
              margin: 0;
            }
          }
        }

        .material-symbols-outlined {
          font-size: 16px;
          margin-right: 4px;
        }

        .rm4-fal {
          font-size: 11px;
          margin-right: 4px;
          width: 16px;
          height: 13px;
        }
      }

      &.rm4-time-grid__time-slot--selected {
        color: #ffffff !important;
        background: #00bfff !important;
      }

      &.rm4-time-grid__time-slot--open {
        color: #c1ffc1;
        background: #50bd50;
      }

      &.rm4-time-grid__time-slot--vip {
        color: #90f492;
        background: #036705;
      }

      &.rm4-time-grid__time-slot--terras {
        color: #c1ffc1;
        background: #389438;

        &.rm4-time-grid__time-slot--drinks {
          color: #e9d0ff;
          background: #6b04c5;
        }
      }

      &.rm4-time-grid__time-slot--drinks {
        color: #fff0dc;
        background: #ffae42;
      }

      &.rm4-time-grid__time-slot--blocked {
        color: #d6cfb9;
        background: #5d5336;
      }

      &:hover {
        cursor: pointer;
      }

      .rm4-time-grid__time-slot__endtime {
        font-size: 10px;
      }
    }
  }
}

.rm4-endtime-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;

  .rm4-endtime-actions__button {
    width: 49%;
    height: 40px;
    font-size: 19px;
    border-radius: 11px;
    border: none;
    cursor: pointer;

    &.rm4-endtime-actions__button--primary {
      background: #00bfff;
      color: #ffffff;
    }
  }
}

.rm4-modal-container--terras {
  text-align: center;

  .rm4-modal-container--terras__bold-text {
    font-weight: bold;
    margin-bottom: 16px;
  }

  .rm4-modal-container--terras__small-text {
    font-size: 67%;
    margin-top: 0px;
  }

  .rm4-modal-container--terras__large-text {
    margin-bottom: 16px;
  }
}

@media (max-width: 576px) {
  .rm4-time-grid {
    .rm4-time-grid__container {
      width: 33.33%;
    }
  }
}
</style>
